import React, { Component } from "react";
import OwlCarousel from "react-owl-carousel2";
import "react-owl-carousel2/src/owl.carousel.css";
import "react-owl-carousel2/src/owl.theme.default.css";
// import view_all_arrow_mm from "../../assets/images/view_all_arrow_mm.png";
import Img from "../../general/Uicomponents/Img"
import { getURLName } from "../../../commonfiles/urlMenu";
import { slugify } from "../../../commonfiles/stringSlugify";
import { isMobile } from "react-device-detect";
import ParseImgURL from "../../utils/parseImgURL";
import { withRouter } from "react-router";
 class LayoutTrailersCarousel extends Component {

 state={
   trailersData:[]
 }
  componentDidMount(){
     this.getTrailersData()

  }
  getTrailersData(){
     if(this.props.trailersData){
    
      this.setState({trailersData:this.props.trailersData})
      
     }
  }
  trailersView=()=>{
    return this.state.trailersData.map((trailer,i)=>{
      return (	<div  onClick={() =>
        this.carouselClick(
          `/${getURLName(trailer,'trailer')}/detail/${trailer.generalInfo._id
          }/${slugify(trailer.generalInfo.title)}`,
          trailer.generalInfo.type,
          trailer.generalInfo.title,
          trailer.images,
          trailer.generalInfo.description
        )
      }
      key={i}>
     <Img
              caroselimg={trailer}
              key={i}
              banner={false}
              layouttype='horizontalListSmallItem'
              caroselname={'trailer'}
              observer={true}
            />
              <div className="episodes-info">
                <span>{trailer.generalInfo.title}</span>
              </div>
    </div>)
    })
  }
  carouselClick = (URL, type, title, images, description) => {
    // console.log(URL)
    // console.log(type)
    // console.log(title)
    // console.log(images)
    // console.log(description)

    var src;
    if (isMobile) {
      src = ParseImgURL(images.values, "mdpi", "coverposter"); //images.values[0].link;
    } else {
      src = ParseImgURL(images.values, "xxhdpi", "coverposter");
    }

    localStorage.setItem("actorImage", src);
    localStorage.setItem("actorType", type);
    localStorage.setItem("personDecription", description);

    if (this.auth) {
      if (type !== "person" && type !== "actor") {
        this.props.history.push(URL);
      } else {
        this.props.history.push(`/Actorprofile/${title}`);
      }
    } else {
      if (type !== "person" && type !== "actor") {
        localStorage.setItem("redirectUrl", URL);
        this.props.history.push(URL);

        // this.props.history.push("/login");
      } else {
        this.props.history.push(`/Actorprofile/${title}`);
      }

      //  this.props.history.push("/login");
    }
  };
  render() {
    
    let perpage = 0;

    if (
      this.props.layoutType === "horizontalListBigItem" ||
      this.props.layoutType === "previewCarousel"||
      this.props.layoutType==="roundedArtistCarousel"
    ) {
      perpage = 10;
    } else if (this.props.layoutType === "nestedCarousel") {
      perpage = 8;
    } else {
      perpage = 7;
    }

    const options = {
      items: perpage,

      responsive: {
        320: {
          items: perpage === 10 ? 2 : perpage === 8 ? 4 : 2,
          nav: true,
        },
        360: {
          items: perpage === 10 ? 3 : perpage === 8 ? 4 : 2,
          nav: true,
        },
        481: {
          items: perpage === 10 ? 3 : perpage === 8 ? 4 : 3,
          nav: false,
        },
        768: {
          items: perpage === 10 ? 4 : perpage === 8 ? 5 : 4,
          nav: false,
        },
        1200: {
          items: perpage === 10 ? 6 : perpage === 8 ? 5 : 5,
          nav: true,
        },
        1300: {
          items: perpage === 10 ? 7 : perpage === 8 ? 6 : 7,
          nav: true,
        },
        1400: {
          items: perpage === 10 ? 8 : perpage === 8 ? 6 : 8,
          nav: true,
        },
        1500: {
          items: perpage === 10 ? 8 : perpage === 8 ? 6 : 8,
          nav: true,
        },
        1600: {
          items: perpage === 10 ? 9 : perpage === 8 ? 7 : 8,
          nav: true,
        },
        1700: {
          items: perpage === 10 ? 10 : perpage === 8 ? 7 : 8,
          nav: true,
        },
      },
      nav: true,
      navText: [
        "<div class='carousel-nav-btn carousel-prev-slide'></div>",
        "<div class='carousel-nav-btn carousel-next-slide'></div>",
      ],
      rewind: false,
      margin: 10,
      dots: false,
      autoplay: false,
      slideBy: 10,
      loop: false,
      touchDrag: true,
      mouseDrag: true,
    };

    const events = {
      onDragged: function (event) { },
      onChanged: function (event) { },
    };
    return (
<div className="profile_radio_carousel detail_news_carousels">
	<div className="carousel_body">
		<div className="home_carosel_title">
			<h1> Trailers and Highlights</h1>
			{/* <img src={view_all_arrow_mm} className="view_all_arrow" alt="viewall_arrow_img" /> */}
		</div>
    {this.state.trailersData.length>0 &&
		<OwlCarousel ref="car" options={options} events={events}>
       {this.trailersView()}
			{/* <div>
				<img src="https://d25tmfuvd960zw.cloudfront.net/122581/640x360_nonDRMFB30Apr_122581_b5efa2f8-ccac-4f70-b379-8752224b9d81.jpg" className="" alt="news_img" />
                <div className="trailers_caption">
                  <p>Maara: Behind the Screens</p>
                </div>
			</div>
			<div>
				<img src="https://d25tmfuvd960zw.cloudfront.net/122546/640x360_nonDRMYouTube27Apr_122546_a4d82fcd-fabf-427b-9340-40c4321173c2.jpg" className="" alt="news_img" />
				<div className="trailers_caption">
                  <p>Maara: Behind the Screens</p>
                </div>
			</div>
			<div>
				<img src="https://d25tmfuvd960zw.cloudfront.net/122582/640x360_nonDRMYouTube30Apr_122582_fda2f05c-fb15-48c7-8a6b-2335d54e7201.jpg" className="" alt="news_img" />
                <div className="trailers_caption">
                  <p>Maara: Behind the Screens</p>
                </div>
			</div>
			<div>
				<img src="https://d25tmfuvd960zw.cloudfront.net/122547/640x360_nonDRMFByoutube27Apr_122547_747ae810-6798-48d1-baf4-96a5a1eba16c.jpg" className="" alt="news_img" />
                <div className="trailers_caption">
                  <p>Maara: Behind the Screens</p>
                </div>
			</div>
			<div>
				<img src="https://d25tmfuvd960zw.cloudfront.net/122544/640x360_NonDrmMpsNews27apr_122544_f6835ac0-c7c0-4ce2-960a-5a005634943d.jpg" className="" alt="news_img" />
                <div className="trailers_caption">
                  <p>Maara: Behind the Screens</p>
                </div>
			</div>
			<div>
				<img src="https://d25tmfuvd960zw.cloudfront.net/122545/640x360_nonDRMFB27Apr_122545_486baeb4-21ab-4c4d-a4c7-0fd0a738e417.jpg" className="" alt="news_img" />
                <div className="trailers_caption">
                  <p>Maara: Behind the Screens</p>
                </div>
			</div>
			<div>
				<img src="https://d25tmfuvd960zw.cloudfront.net/122581/640x360_nonDRMFB30Apr_122581_b5efa2f8-ccac-4f70-b379-8752224b9d81.jpg" className="" alt="news_img" />
                <div className="trailers_caption">
                  <p>Maara: Behind the Screens</p>
                </div>
			</div>
			<div>
				<img src="https://d25tmfuvd960zw.cloudfront.net/122546/640x360_nonDRMYouTube27Apr_122546_a4d82fcd-fabf-427b-9340-40c4321173c2.jpg" className="" alt="news_img" />
                <div className="trailers_caption">
                  <p>Maara: Behind the Screens</p>
                </div>
			</div>
			<div>
				<img src="https://d25tmfuvd960zw.cloudfront.net/122582/640x360_nonDRMYouTube30Apr_122582_fda2f05c-fb15-48c7-8a6b-2335d54e7201.jpg" className="" alt="news_img" />
                <div className="trailers_caption">
                  <p>Maara: Behind the Screens</p>
                </div>
			</div>
			<div>
				<img src="https://d25tmfuvd960zw.cloudfront.net/122547/640x360_nonDRMFByoutube27Apr_122547_747ae810-6798-48d1-baf4-96a5a1eba16c.jpg" className="" alt="news_img" />
                <div className="trailers_caption">
                  <p>Maara: Behind the Screens</p>
                </div>
			</div>
			<div>
				<img src="https://d25tmfuvd960zw.cloudfront.net/122544/640x360_NonDrmMpsNews27apr_122544_f6835ac0-c7c0-4ce2-960a-5a005634943d.jpg" className="" alt="news_img" />
                <div className="trailers_caption">
                  <p>Maara: Behind the Screens</p>
                </div>
			</div>
			<div>
				<img src="https://d25tmfuvd960zw.cloudfront.net/122545/640x360_nonDRMFB27Apr_122545_486baeb4-21ab-4c4d-a4c7-0fd0a738e417.jpg" className="" alt="news_img" />
                <div className="trailers_caption">
                  <p>Maara: Behind the Screens</p>
                </div>
			</div> */}
		</OwlCarousel>}
	</div>
</div>
    );
  }
}
export default withRouter(LayoutTrailersCarousel)